import { Tooltip } from "@xola/ui-kit";
import React, { ReactElement, ReactNode } from "react";
import { NoTranslate } from "../../Common/NoTranslate";
import { ResourceDisplay } from "../Resources/ResourceDisplay";

interface BasicInfoProps {
    text: ReactNode;
    icon: ReactElement;
    count: number;
    total?: number;
    shouldShowDot?: boolean;
    shouldAutoHide?: boolean;
    className?: string;
    testId?: string;
}

export const BasicInfo = ({
    text,
    icon,
    count,
    total,
    className,
    testId = "",
    shouldShowDot = true,
    shouldAutoHide = false,
}: BasicInfoProps) => {
    // Color is danger if it's not 100%
    const color = count === total || !total ? "success" : "danger";

    return (
        <div className={className} data-testid={testId}>
            {shouldAutoHide && count === 0 ? null : (
                <Tooltip content={text}>
                    <ResourceDisplay shouldShowDot={shouldShowDot} color={color} icon={icon}>
                        <NoTranslate>
                            {count}
                            {total ? `/${total}` : null}
                        </NoTranslate>
                    </ResourceDisplay>
                </Tooltip>
            )}
        </div>
    );
};
